import axios from 'axios';

import {
    CONSENT__GET__START,
    CONSENT__GET__SUCCESS,
    CONSENT__GET__FAILURE,
    CONSENT__GET__RESET,
    CONSENT__SET__START,
    CONSENT__SET__SUCCESS,
    CONSENT__SET__FAILURE,
} from './actions';

function getConsentStart() {
    return {
        type: CONSENT__GET__START,
    };
}

function getConsentSuccess(data) {
    return {
        type: CONSENT__GET__SUCCESS,
        data,
    };
}

function getConsentFailure(error) {
    return {
        type: CONSENT__GET__FAILURE,
        error,
    };
}

function getConsentReset() {
    return {
        type: CONSENT__GET__RESET,
    };
}

export function resetConsent() {
    return dispatch => {
        dispatch(getConsentReset());
    };
};

export function getConsent(token) {
    const data = {
        data: {
            token,
        },
    };
    return dispatch => {
        dispatch(getConsentStart());
        const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}`;
        return axios.post(`${baseUrl}/v1/consent/get`, { ...data }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                      errorCode,
                      errorMessage,
                      processToData,
                      processToDataDealer,
                      receiveAdvertising,
                    } = response.data.data;

                    const error = errorMessage || errorCode;

                    if (!errorCode) {
                        dispatch(getConsentSuccess({
                            processToData,
                            processToDataDealer,
                            receiveAdvertising,
                        }));
                    } else {
                        throw new Error(error);
                    }
                } else {
                    dispatch(getConsentFailure(true));
                }
            })
            .catch(error => {
                if (error.response.data.errorCode === 19000) {
                    dispatch(setConsent('processing_personal_data', true, token));
                    dispatch(setConsent('receive_advertising', true, token));
                }
                dispatch(getConsentFailure(new Error(error)));
            });
    };
}

function setConsentStart() {
    return {
        type: CONSENT__SET__START,
    };
}

function setConsentSuccess(data) {
    return {
        type: CONSENT__SET__SUCCESS,
        data,
    };
}

function setConsentFailure(error) {
    return {
        type: CONSENT__SET__FAILURE,
        error,
    };
}

export function setConsent(type, value, token) {
    console.log(type, value, token);
    const data = {
        data: {
            type,
            value,
            token,
        },
    };
    return dispatch => {
        dispatch(setConsentStart());
        const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}`;
        return axios.post(`${baseUrl}/v1/consent/switch`, { ...data }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        errorCode,
                        errorMessage,
                        processToData,
                        processToDataDealer,
                        receiveAdvertising,
                    } = response.data.data;

                    const error = errorMessage || errorCode;

                    if (!errorCode) {
                        dispatch(setConsentSuccess({
                            processToData,
                            processToDataDealer,
                            receiveAdvertising,
                        }));
                    } else {
                        throw new Error(error);
                    }
                } else {
                    dispatch(setConsentFailure(true));
                }
            })
            .catch(error => {
                dispatch(setConsentFailure(new Error(error)));
            });
    };
}
